export const PAGE_SOURCE = 'SourceTracking'
export const EXPERIMENT_VIEWED = 'Experiment Viewed'
export const SELL_BUTTON_CLICKED = 'Sell Button Clicked'
export const LOGOUT_COMPLETED = 'LogoutCompleted'
export const SEARCH_STARTED = 'Search Started'
export const SEARCH_COMPLETED = 'Search Completed'
export const SEARCH_RESULT_CLICKED = 'Search Result Clicked'
export const FILTER_OPENED = 'Filter Opened'
export const FILTER_OPTION_SELECTED = 'Filter Option Selected'
export const EXPLORE_CONTENT_CLICKED = 'Explore Content Clicked'
export const TERMS_PRIVACY_CONSENT_ACCEPTED = 'TermsPrivacyConsentAccepted'
export const TERMS_PRIVACY_CONSENT_REJECTED = 'TermsPrivacyConsentRejected'
export const TERMS_PRIVACY_CONSENT_VIEWED = 'TermsPrivacyConsentViewed'
export const LOCALE_BAR_VIEWED = 'LocaleBarViewed'
export const LOCALE_BAR_DISMISSED = 'LocaleBarDismissed'
export const LOCALE_BAR_SET = 'LocaleBarSet'
export const AUTHENTICATION_VIEWED = 'Authentication Viewed'
export const AUTHENTICATION_STARTED = 'Authentication Started'
export const AUTHENTICATION_COMPLETED = 'Authentication Completed'
export const VERIFICATION_STARTED = 'VerificationStarted'
export const EVENT_VIEWED = 'Event Viewed'
export const EVENT_INFO_VIEWED = 'Event Info Viewed'
export const EVENT_TYPE_VIEWED = 'Event Type Viewed'
export const LOCATION_URL_CLICKED = 'Location URL Clicked'
export const LISTING_VIEWED = 'ListingViewed'
export const LISTING_VIEWED_FAILED = 'Listing Viewed Failed'
export const LISTING_CLICKED = 'Listing Clicked'
export const CONTENT_INTENDED_TO_SELL = 'ContentIntendedToSell'
export const CONTENT_INTENDED_TO_BUY = 'ContentIntendedToBuy'
export const TICKET_ALERT_CREATION_FAILED = 'TicketAlertCreationFailed'
export const TICKET_ALERT_EDIT_CLICKED = 'TicketAlertEditClicked'
export const TICKET_ALERT_REMOVE_CLICKED = 'TicketAlertRemoveClicked'
export const TICKET_ALERT_ENABLED = 'Ticket Alert Enabled'
export const TICKET_ALERT_UPDATED = 'Ticket Alert Updated'
export const TICKET_ALERT_DISABLED = 'Ticket Alert Disabled'
export const RESELL_CONTACT_CLICKED = 'ResellContactClicked'
export const RESELL_REJECTED = 'ResellRejected'
export const RESELL_STARTED = 'ResellStarted'
export const ORIGINAL_PRICE_UPDATED = 'OriginalPriceUpdated'
export const SELLING_PRICE_SUGGESTIONS_SELECTED = 'SellingPriceSuggestionsSelected'
export const PHONE_UPDATED = 'PhoneUpdated'
export const PHONE_SMS_SENT = 'PhoneSmsSent'
export const PHONE_WITHOUT_UPDATE = 'PhoneWithoutUpdate'
export const PHONE_VERIFY_COMPLETED = 'PhoneVerifyCompleted'
export const PHONE_VERIFY_SKIPPED = 'PhoneVerifySkipped'
export const SUMMARY_ROW_CLICKED = 'SummaryRowClicked'
export const SUMMARY_CREATE_NEW_DRAFT = 'SummaryCreateNewDraft'
export const RESELL_COMPLETED = 'ResellCompleted'
export const FILE_UPLOAD_STARTED = 'File Upload Started'
export const FILE_UPLOAD_FAILED = 'File Upload Failed'
export const FILE_UPLOAD_COMPLETED = 'File Upload Completed'
export const FILE_REMOVED = 'FileRemoved'
export const TICKET_INFO_SEATING_FORCED = 'TicketInfoSeatingForced'
export const TICKET_INFO_SKIP = 'TicketInfoSkip'
export const TICKET_INFO_ERROR_SHOWN = 'TicketInfoErrorShown'
export const TICKET_INFO_PROCEED = 'TicketInfoProceed'
export const SOCIAL_STEP_SKIPPED = 'SocialStepSkipped'
export const SELL_SOCIAL_STEP_ERRORS = 'Sell Social Step Errors'
export const EVENT_DESELECTED = 'EventDeselected'
export const EVENT_TYPE_DESELECTED = 'EventTypeDeselected'
export const EVENT_TYPE_SELECTED = 'EventTypeSelected'
export const EVENT_CREATE = 'EventCreate'
export const ADD_EVENT_FAILED = 'Add Event Failed'
export const RESELL_FOUND_VIA_SELL_FLOW = 'ResellFoundViaSellFlow'
export const TICKET_NOT_UPDATED = 'TicketNotUpdated'
export const TICKET_UPDATED = 'TicketUpdated'
export const COPIED_SHARE_LINK = 'CopiedShareLink'
export const SHARED_ON_TWITTER = 'SharedOnTwitter'
export const SHARED_ON_FACEBOOK = 'SharedOnFacebook'
export const BREADCRUMB_CLICKED = 'Breadcrumb Clicked'
export const PUBLISH_STEP_VIEWED = 'Publish Step Viewed'
export const PUBLISH_SUMMARY_VIEWED = 'Publish Summary Viewed'
export const PUBLISH_STARTED = 'Publish Started'
export const PUBLISH_FAILED = 'Publish Failed'
export const PUBLISH_COMPLETED = 'Publish Completed'
export const PERSONALISE_DIALOG_DISMISSED = 'PersonaliseDialogDismissed'
export const TICKET_DOWNLOAD_CLICKED = 'Ticket Download Clicked'
export const TICKET_PERSONALIZE_STARTED = 'Ticket Personalize Started'
export const TICKET_PERSONALIZE_COMPLETED = 'Ticket Personalize Completed'
export const TICKETS_VIEWED = 'Tickets Viewed'
export const TICKET_DETAILS_VIEWED = 'Ticket Details Viewed'
export const SELL_STARTED = 'Sell Started'
export const SHARE_TICKET_CLICKED = 'Share Ticket Clicked'
export const ACCEPT_SHARED_TICKET_SCREEN_VIEWED = 'Accept Shared Ticket Screen Viewed'
export const ACCEPT_SHARED_TICKET_STARTED = 'Accept Shared Ticket Started'
export const ACCEPT_SHARED_TICKET_COMPLETED = 'Accept Shared Ticket Completed'
export const FACEBOOK_EVENTS_CONNECTED = 'Facebook Events Connected'
export const FACEBOOK_EVENT_CLICKED = 'Facebook Event Clicked'
export const SOCIAL_DISCONNECT_FACEBOOK = 'Social Disconnect Facebook'
export const SOCIAL_DISCONNECT_TWITTER = 'Social Disconnect Twitter'
export const PRODUCT_ADDED = 'Product Added'
export const CART_VIEWED = 'Cart Viewed'
export const PRODUCT_REMOVED = 'Product Removed'
export const CHECKOUT_STARTED = 'Checkout Started'
export const CHECKOUT_STEP_VIEWED = 'Checkout Step Viewed'
export const CHECKOUT_STEP_COMPLETED = 'Checkout Step Completed'
export const ORDER_COMPLETED = 'Order Completed'
export const CHECKOUT_KARTENT_VIEWED = 'Checkout Kartent Viewed'
export const CHECKOUT_KARTENT_ADDED = 'Checkout Kartent Added'
export const CHECKOUT_KARTENT_REMOVED = 'Checkout Kartent Removed'
export const CHECKOUT_PAYMENT_CC_ERROR = 'Checkout Payment CC Error'
export const CHECKOUT_EMAIL_CHANGE = 'Checkout Email Change'
export const CHECKOUT_PHONE_COUNTRY_CHANGE = 'Checkout Phone Country Change'
export const CHECKOUT_PHONE_NUMBER_CHANGE = 'Checkout Phone Number Change'
export const CHECKOUT_COMPLETED = 'Checkout Completed'
export const CHECKOUT_PHONE_VERIFY_CHANGE = 'Checkout Phone Verify Change'
export const CHECKOUT_PHONE_VERIFY_FAILED = 'Checkout Phone Verify Failed'
export const CHECKOUT_PROCESSING_VIEWED = 'Checkout Processing Viewed'
export const CHECKOUT_PROCESSING_HIDDEN = 'Checkout Processing Hidden'
export const CHECKOUT_LOGIN_REQUIRED = 'Checkout Login Required'
export const CHECKOUT_PAY_BUTTON_CLICKED = 'Checkout Pay Button Clicked'
export const CHECKOUT_CONFIRMATION_VIEWED = 'Checkout Confirmation Viewed'
export const EMAIL_VERIFICATION_STARTED = 'Email Verification Started'
export const ACCOUNT_EXPORT_REQUESTED = 'Account Export Requested'
export const ARTIST_VIEWED = 'Artist Viewed'
export const ARTIST_CLICKED = 'Artist Clicked'
export const RECOMMENDATION_CLICKED = 'Recommendation Clicked'
export const HELP_REACHED = 'Help Reached'
export const SOCIAL_MEDIA_CLICKED = 'Social Media Clicked'
export const ADD_SOCIAL_MEDIA_COMPLETED = 'Add Social Media Completed'
export const EVENT_REVIEW_SUBMITTED = 'Event Review Submitted'
export const APP_DOWNLOAD_CLICKED = 'App Download Clicked'
export const APP_DOWNLOAD_DIALOG_CLOSED = 'App Download Dialog Closed'
export const APP_DOWNLOAD_DIALOG_VIEWED = 'App Download Dialog Viewed'
export const REPORT_EVENT_UPDATE_STARTED = 'Report Event Update Started'
export const REPORT_EVENT_UPDATE_COMPLETED = 'Report Event Update Completed'
export const START_CASE_ACCEPTED = 'Start case accepted'
export const CASE_ACTION_APPLIED = 'Case action applied'
export const AUTO_RESERVATION_CREATED = 'AutoReservationCreated'
export const BROWSE_EVENTS_CLICKED = 'Browse Events Clicked'
export const EXPLORE_FEED_ITEM_TAPPED = 'Explore Feed Item Tapped'
export const EXPLORE_FEED_SEE_ALL_CLICKED = 'Explore Feed See All Clicked'
export const EXPLORE_FEED_ITEM_VIEWED = 'Explore Feed Item Viewed'
export const UNSUBSCRIBE_COMPLETED = 'Unsubscribe Completed'
export const UNSUBSCRIBE_FEEDBACK_GIVEN = 'Unsubscribe Feedback Given'
export const PARTNER_DASHBOARD_CLICKED = 'Partner Dashboard Clicked'
export const PARTNER_LIST_VIEWED = 'Partner List Viewed'
export const PARTNER_EVENTS_LIST_VIEWED = 'Partner Events List Viewed'
export const PARTNER_EVENT_ADD_VIEWED = 'Partner Event Add Viewed'
export const PARTNER_EVENT_CREATE_VIEWED = 'Partner Event Create Viewed'
export const PARTNER_EXPORT_DATA_CLICKED = 'Partner Export Data Clicked'
export const PARTNER_EDIT_EVENT_VIEWED = 'Partner Edit Event Viewed'
export const EVENT_SELECTED = 'Event Selected'
export const CHANGE_HEADER_IMAGE_STARTED = 'Change Header Image Started'
export const CHANGE_HEADER_IMAGE_SELECTED = 'Change Header Image Selected'
export const CHANGE_HEADER_IMAGE_COMPLETED = 'Change Header Image Completed'
export const RANDOM_IMAGE_SELECTED = 'Random Image Selected'
export const EVENT_DESCRIPTION_UPDATED = 'Event Description Updated'
export const EVENT_VIDEO_URL_UPDATED = 'Event Video Url Updated'
export const VIDEO_CLICKED = 'Video Clicked'
export const ORGANIZER_MARKETING_CONSENT_DISPLAYED = 'Organizer Marketing Consent Displayed'
export const ORGANIZER_MARKETING_CONSENT_GIVEN = 'Organizer Marketing Consent Given'
export const FUNDRAISING_FORM_SUBMITTED = 'Fundraising Form Submitted'
export const STOP_SHARING_STARTED = 'Stop Sharing Started'
export const STOP_SHARING_COMPLETED = 'Stop Sharing Completed'
export const CHANGE_PAYOUT_INFORMATION_FAILED = 'Change Payout Information Failed'
export const VERIFY_IDENTITY_STARTED = 'Verify Identity Started'
export const VERIFY_IDENTITY_COMPLETED = 'Verify Identity Completed'
export const VERIFY_IDENTITY_FAILED = 'Verify Identity Failed'
export const IDENTITY_DOCUMENT_STARTED = 'Identity Document Started'
export const IDENTITY_DOCUMENT_COMPLETED = 'Identity Document Completed'
export const IDENTITY_DOCUMENT_FAILED = 'Identity Document Failed'
export const STRIPE_UNAVAILABLE = 'Stripe Unavailable'
export const STRIPE_FAILED = 'Stripe Failed'
export const KYC_FAILED = 'KYC Failed'
export const NATIVE_BRIDGE_FAILED = 'Native Bridge Failed'
export const PARTNER_PAGE_FORM_SUBMITTED = 'Partner Page Form Submitted'
export const RAFFLE_STATE_FETCH_FAILED = 'Raffle State Fetch Failed'
export const TRUSTPILOT_PAGE_OPENED = 'Trustpilot Page Opened'
export const TRUSTPILOT_SCORE_CLICKED = 'Trustpilot Score Clicked'
export const BETA_FEATURE_ENABLED = 'Beta Feature Enabled'
export const BETA_FEATURE_DISABLED = 'Beta Feature Disabled'
export const CASE_STARTED_FROM_TICKET = 'Case Started From Ticket'
